import useApi from '../../../services/useApi'

const useGetPurchasersDropdown = () => {
  const Api = useApi()
  const {data: response, isFetching} = Api.useGetQuery(
    '/products/inquiries/filters/purchaser'
  )

  return {
    purchasers: response?.data || [],
    isPurchasersLoading: isFetching,
  }
}

export default useGetPurchasersDropdown
